import { toTitleCase } from "../../../../Utils/stringUtls";

const ContactInformationOverview = ({ data }) => {
  const {
    cp_ci_pm_name,
    cp_ci_pm_title,
    cp_ci_pm_phone_number,
    cp_ci_pm_phone_number_country,
    cp_ci_pm_cell_number,
    cp_ci_pm_cell_number_country,
    cp_ci_pm_email,
    cp_ci_pm_sign,
    cp_ci_sc_is_primary,
    cp_ci_sc_name,
    cp_ci_sc_title,
    cp_ci_sc_phone_number,
    cp_ci_sc_phone_number_country,
    cp_ci_sc_cell_number,
    cp_ci_sc_cell_number_country,
    cp_ci_sc_email,
    cp_ci_brn_is_primary,
    cp_ci_brn_name,
    cp_ci_brn_title,
    cp_ci_brn_phone_number,
    cp_ci_brn_phone_number_country,
    cp_ci_brn_cell_number,
    cp_ci_brn_cell_number_country,
    cp_ci_brn_email,
    cp_ci_mn_is_primary,
    cp_ci_mn_name,
    cp_ci_mn_title,
    cp_ci_mn_phone_number,
    cp_ci_mn_phone_number_country,
    cp_ci_mn_cell_number,
    cp_ci_mn_cell_number_country,
    cp_ci_mn_email,
    cp_ci_supp_name,
    cp_ci_supp_title,
    cp_ci_supp_phone_number,
    cp_ci_supp_phone_number_country,
    cp_ci_supp_cell_number,
    cp_ci_supp_cell_number_country,
    cp_ci_supp_email,
    cp_ci_supp_is_primary,
    cp_ci_ad_is_primary,
    cp_ci_ad_name,
    cp_ci_ad_title,
    cp_ci_ad_phone_number,
    cp_ci_ad_phone_number_country,
    cp_ci_ad_cell_number,
    cp_ci_ad_cell_number_country,
    cp_ci_ad_email,
    cp_ci_eep_name,
    cp_ci_eep_title,
    cp_ci_eep_phone_number,
    cp_ci_eep_phone_number_country,
    cp_ci_eep_cell_number,
    cp_ci_eep_cell_number_country,
    cp_ci_eep_email,
    cp_ci_ees_name,
    cp_ci_ees_title,
    cp_ci_ees_phone_number,
    cp_ci_ees_phone_number_country,
    cp_ci_ees_cell_number,
    cp_ci_ees_cell_number_country,
    cp_ci_ees_email,
  } = data["2_0"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Contact Information
        </div>

        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Project Manager or Primary Contact for Program Management
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {cp_ci_pm_name?.length ? toTitleCase(cp_ci_pm_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Job Title</div>
          <div className="overview-val-text">
            {cp_ci_pm_title?.length ? toTitleCase(cp_ci_pm_title) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_ci_pm_phone_number?.length ? cp_ci_pm_phone_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Cell Number</div>
          <div className="overview-val-text">
            {cp_ci_pm_cell_number?.length ? cp_ci_pm_cell_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_ci_pm_email?.length ? toTitleCase(cp_ci_pm_email) : "-"}
          </div>
        </div>
        <div i2c-grid="12">
          <div className="overview-help-text font-bold">
            Does this person have signature approval?
          </div>
          <div className="overview-val-text">{toTitleCase(cp_ci_pm_sign)}</div>
        </div>

        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Seconday Contact
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {cp_ci_sc_name?.length ? toTitleCase(cp_ci_sc_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Job Title</div>
          <div className="overview-val-text">
            {cp_ci_sc_title?.length ? toTitleCase(cp_ci_sc_title) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_ci_sc_phone_number?.length ? cp_ci_sc_phone_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Cell Number</div>
          <div className="overview-val-text">
            {cp_ci_sc_cell_number?.length ? cp_ci_sc_cell_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_ci_sc_email?.length ? toTitleCase(cp_ci_sc_email) : "-"}
          </div>
        </div>

        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Contact for Business Release Notes
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {cp_ci_brn_name?.length ? toTitleCase(cp_ci_brn_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Job Title</div>
          <div className="overview-val-text">
            {cp_ci_brn_title?.length ? toTitleCase(cp_ci_brn_title) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_ci_brn_phone_number?.length ? cp_ci_brn_phone_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Cell Number</div>
          <div className="overview-val-text">
            {cp_ci_brn_cell_number?.length ? cp_ci_brn_cell_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_ci_brn_email?.length ? toTitleCase(cp_ci_brn_email) : "-"}
          </div>
        </div>

        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Contact for Maintenance Notification
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {cp_ci_mn_name?.length ? toTitleCase(cp_ci_mn_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Job Title</div>
          <div className="overview-val-text">
            {cp_ci_mn_title?.length ? toTitleCase(cp_ci_mn_title) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_ci_mn_phone_number?.length ? cp_ci_mn_phone_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Cell Number</div>
          <div className="overview-val-text">
            {cp_ci_mn_cell_number?.length ? cp_ci_mn_cell_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_ci_mn_email?.length ? toTitleCase(cp_ci_mn_email) : "-"}
          </div>
        </div>

        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Contact for Support
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {cp_ci_supp_name?.length ? toTitleCase(cp_ci_supp_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Job Title</div>
          <div className="overview-val-text">
            {cp_ci_supp_title?.length ? toTitleCase(cp_ci_supp_title) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_ci_supp_phone_number?.length ? cp_ci_supp_phone_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Cell Number</div>
          <div className="overview-val-text">
            {cp_ci_supp_cell_number?.length ? cp_ci_supp_cell_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_ci_supp_email?.length ? toTitleCase(cp_ci_supp_email) : "-"}
          </div>
        </div>

        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Contact for Accounting Department
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {cp_ci_ad_name?.length ? toTitleCase(cp_ci_ad_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Job Title</div>
          <div className="overview-val-text">
            {cp_ci_ad_title?.length ? toTitleCase(cp_ci_ad_title) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_ci_ad_phone_number?.length ? cp_ci_ad_phone_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Cell Number</div>
          <div className="overview-val-text">
            {cp_ci_ad_cell_number?.length ? cp_ci_ad_cell_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_ci_ad_email?.length ? toTitleCase(cp_ci_ad_email) : "-"}
          </div>
        </div>

        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Contact for Executive Escalation – Primary
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {cp_ci_eep_name?.length ? toTitleCase(cp_ci_eep_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Job Title</div>
          <div className="overview-val-text">
            {cp_ci_eep_title?.length ? toTitleCase(cp_ci_eep_title) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_ci_eep_phone_number?.length ? cp_ci_eep_phone_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Cell Number</div>
          <div className="overview-val-text">
            {cp_ci_eep_cell_number?.length ? cp_ci_eep_cell_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_ci_eep_email?.length ? toTitleCase(cp_ci_eep_email) : "-"}
          </div>
        </div>

        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
        >
          Contact for Executive Escalation – Secondary
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {cp_ci_ees_name?.length ? toTitleCase(cp_ci_ees_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Job Title</div>
          <div className="overview-val-text">
            {cp_ci_ees_title?.length ? toTitleCase(cp_ci_ees_title) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_ci_ees_phone_number?.length ? cp_ci_ees_phone_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Cell Number</div>
          <div className="overview-val-text">
            {cp_ci_ees_cell_number?.length ? cp_ci_ees_cell_number : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_ci_ees_email?.length ? toTitleCase(cp_ci_ees_email) : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactInformationOverview;
